var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',[_c('MediaManager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }